import http from 'conversations-http/clients/http';
export const fetchChannelInstanceById = ({
  channelInstanceId
}) => {
  return http.get(`conversations-channels/v1/channel-instances/${channelInstanceId}`);
};